
import banImg1 from "../../assets/images/services/web-development/web-banner.webp";
import banImg2 from "../../assets/images/services/android-app-development/introduction-android.webp";
import features01 from "../../assets/images/services/web-development/web-featu-01.webp"
import features02 from "../../assets/images/services/web-development/web-featu-02.webp"
import features03 from "../../assets/images/services/web-development/web-featu-03.webp"
import features04 from "../../assets/images/services/web-development/web-featu-04.webp"
import features05 from "../../assets/images/services/web-development/web-featu-05.webp"
import features06 from "../../assets/images/services/web-development/web-featu-06.webp"
import features07 from "../../assets/images/services/web-development/web-featu-07.webp"
import features08 from "../../assets/images/services/web-development/web-featu-08.webp"

const WebDevelopmentData = {
    "BannerData":[
        {
            "title": "Dynamic <span>Web Development</span> <br/> Solutions",
            "bannerBtnText": 'Let’s Connect',
            "bannerBigimg" : `${banImg1}`,
            "bannerAlt": 'Web Development',
        },
    ],

    "Introduction":[
        {
            "introContent" :`Our Web Development service is your gateway to creating powerful online experiences that resonate with your audience. Whether you need a responsive website, a scalable web application, or an e-commerce platform, our expert team is ready to turn your vision into reality. We combine creativity, functionality, and cutting-edge technologies to deliver web solutions that drive results.`,
            "introImg": `${banImg2}`,
            "brochurelink": "/",
        }
    ],

    "ServiceBenifits" : [
        {   
            "benifitCont" : "Engage your audience with visually appealing and user-friendly websites",
        },
        {
            "benifitCont" : "Reach customers on any device with responsive design principles",
        },
        {
            "benifitCont" : "Increase conversions with optimized performance and usability",
        },
        {
            "benifitCont" : "Scale your web presence as your business grows",
        },
        {
            "benifitCont" : "Ensure data security and compliance with industry standards",
        },
        {
            "benifitCont" : "Enjoy continuous support and updates for a hassle-free experience",
        },
    ],

    "FeaturesServices":[
        {
          
            "featureDescriptiom":"Custom web development tailored to your business objectives",
            "FeatImg" : `${features01}`,
            "FeatImgAltTag" : "Custom web development tailored to your business objectives",
            
        },
        {
            
            "featureDescriptiom":"Responsive design for seamless user experiences across devices",
            "FeatImg" : `${features02}`,
            "FeatImgAltTag" : "Responsive design for seamless user experiences across devices",
        },
        {
            
            "featureDescriptiom":"Integration with databases, APIs, and third-party services",
            "FeatImg" : `${features03}`,
            "FeatImgAltTag" : "Integration with databases, APIs, and third-party services",
        },
        {
            
            "featureDescriptiom":"Use of modern technology stacks with React, Next.js, Angular",
            "FeatImg" : `${features04}`,
            "FeatImgAltTag" : "Use of modern technology stacks with React, Next.js, Angular",
        },
        {
            
            "featureDescriptiom":"Concurrent & High-performance programming languages Go-Lang, C#, PHP8, Node.js",
            "FeatImg" : `${features05}`,
            "FeatImgAltTag" : "Concurrent & High-performance programming languages Go-Lang, C#, PHP8, Node.js",
        },
        {
            
            "featureDescriptiom":"Content management systems (CMS) for easy updates and management",
            "FeatImg" : `${features06}`,
            "FeatImgAltTag" : "Content management systems (CMS) for easy updates and management",
        },
        {
            
            "featureDescriptiom":"Rigorous testing across browsers and devices",
            "FeatImg" : `${features07}`,
            "FeatImgAltTag" : "Rigorous testing across browsers and devices",
        },
        {
            
            "featureDescriptiom":"Security measures for data protection and user privacy",
            "FeatImg" : `${features08}`,
            "FeatImgAltTag" : "Security measures for data protection and user privacy",
        },
    ],


    "FooterCtaSection":[
        {
            "CtaDescriptiom":"Elevate your online presence with a custom web solution. Contact us today to discuss your project requirements and discover how our Web Development service can help you achieve your digital goals.",
            "CtaBtnText": 'Let’s Connect',
            "CtaBtnLink": '/get-a-quote',
        },
    ],


    
} 

export default WebDevelopmentData